var React = require('react');

function Dreidel (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M443.3 82l-109 109 72 71.9a33.38 33.38 0 0 1 0 47.3l-68.7 68.7-236.4-236.45 68.7-68.7a33.38 33.38 0 0 1 47.3 0l71.9 71.9 109-109a16.06 16.06 0 0 1 22.6 0l22.6 22.6a16 16 0 0 1 0 22.75z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M78.5 165.05l236.4 236.4-58.9 58.9A66.83 66.83 0 0 1 208.7 480H66.9A66.83 66.83 0 0 1 0 413.05v-141.8A66.49 66.49 0 0 1 19.6 224z","className":"fa-primary","key":2})]);
}

Dreidel.defaultProps = {"viewBox":"0 0 448 512","className":"icon"};

module.exports = Dreidel;

Dreidel.default = Dreidel;
